












































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

export interface PaginationModel {
  sortBy: string;
  descending: boolean;
  /**当前页数 */
  page: number;
  /**每页条数 */
  rowsPerPage: number; // -1 for All",
  /**数据总数 */
  totalItems: number;
  /**可选择的每页条数 */
  pageSizes: number[];
}

@Component({ name: 'ams-pagination' })
export default class AMSPagination extends Vue {
  @Prop({
    default: () => {
      return { descending: false, page: 0, rowsPerPage: 0, totalItems: 0 };
    }
  })
  pageConfig!: PaginationModel;
  @Prop({ default: true }) isChangePage?: Boolean;
  @Prop({ default: true }) pagechangeNum?: Number;

  page: number = 1;
  jumpPage: string = '1';
  pageSize: number = 0;
  changePage: number = 1;
  showPageSizeMenu: boolean = false;

  onPagenationPageChange(p: any) {
    this.$emit('onPageChange', this.page - 1);
  }

  @Watch('pageConfig', { immediate: true, deep: true })
  onPageConfigChange(value: any, oldValue: any) {
    this.page = value.page ? value.page + 1 : 1;
  }

  created() {
    this.pageSize = this.pageConfig.pageSizes[0];
  }

  /**下一页 */
  nextPage() {
    this.$emit('onNextPage', this.page - 1);
  }

  /**上一页 */
  previousPage() {
    this.$emit('onPreviousPage', this.page - 1);
  }

  /**跳转到某页 */
  jumpToPage() {
    let num = Number(this.jumpPage);
    this.$emit('jumpToPage', this.page, num);
    if (num == undefined) {
      this.jumpPage = '1';
      //this.page = 1;
    } else {
      if (num >= 1 && num <= this.getTotalPage()) {
        this.page = num;
        this.$emit('onPageChange', this.page - 1);
      } else {
        this.jumpPage = '1';
        //this.page = 1;
      }
    }
  }

  /**选中了某个page size */
  pageSizeSelect(item: number) {
    if (this.pageSize != item) {
      this.page = 1;
      this.pageConfig.page = 0; //给后台传第一页为0
      this.pageSize = item;
      this.$emit('onPageSizeChange', this.pageSize);
    }
  }

  /**获取总页数 */
  getTotalPage() {
    return Math.ceil(this.pageConfig.totalItems / this.pageConfig.rowsPerPage);
  }

  get getTotalDesct() {
    return `共${this.getTotalPage()}页/${this.pageConfig.totalItems}条数据`;
  }
}
